module.exports = __webpack_public_path__ + "housingStatic/img/full_screen_retract.f297013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upper/full_screen_retract.png
// module id = w4I5
// module chunks = 2